import { render } from "./Help.component.vue?vue&type=template&id=b7d62188"
import script from "./Help.component.vue?vue&type=script&lang=js"
export * from "./Help.component.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__